<!-- 经营信息 -->
<template>
  <div class="business-info-view">
    <el-form :model="queryParams" :rules="rules" ref="BusinessInfoForm">
      <p class="info-title">联系信息与公开信息</p>

      <div class="business-info-block">
        <el-form-item
          label="企业官网："
          label-width="190px"
          prop="companyWebsite"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入官网"
            v-model="queryParams.companyWebsite"
          />
        </el-form-item>

        <el-form-item
          label="企业电话："
          label-width="190px"
          prop="companyTelephone"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入企业电话"
            v-model="queryParams.companyTelephone"
          />
        </el-form-item>

        <el-form-item
          label="企业邮箱："
          label-width="190px"
          prop="companyEmail"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入企业邮箱"
            v-model="queryParams.companyEmail"
          />
        </el-form-item>

        <el-form-item
          label="微信公众号："
          label-width="190px"
          prop="companyWechat"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入微信公众号"
            v-model="queryParams.companyWechat"
          />
        </el-form-item>

        <el-form-item
          label="企业微博："
          label-width="190px"
          prop="companyWeibo"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入企业微博"
            v-model="queryParams.companyWeibo"
          />
        </el-form-item>

        <el-form-item
          label="领英网址："
          label-width="190px"
          prop="companyLinkEdin"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入领英网址"
            v-model="queryParams.companyLinkEdin"
          />
        </el-form-item>
      </div>

      <p class="info-title">企业规模</p>

      <div class="business-info-block">
        <el-form-item
          label="当前社保人数："
          label-width="190px"
          prop="socialSecurityNumber"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入社保人数"
            v-model="queryParams.socialSecurityNumber"
          />
        </el-form-item>

        <el-form-item
          label="过去第一年社保人数："
          label-width="190px"
          prop="lastYearSbrs"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入社保人数"
            v-model="queryParams.lastYearSbrs"
          />
        </el-form-item>

        <el-form-item
          label="过去第二年社保人数："
          label-width="190px"
          prop="qnSbrs"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入社保人数"
            v-model="queryParams.qnSbrs"
          />
        </el-form-item>

        <el-form-item label="企业规模：" label-width="190px" prop="companySize">
          <el-radio-group v-model="queryParams.companySize">
            <el-radio
              v-for="(item, index) in enterpriseSize"
              :key="index"
              :label="item.codeId"
              >{{ item.codeName }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="纳税人类型："
          label-width="190px"
          prop="taxpayerType"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入纳税人类型"
            v-model="queryParams.taxpayerType"
          />
        </el-form-item>

        <el-form-item
          label="过去第一年营收范围："
          label-width="190px"
          prop="lastYearYsfw"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入过去第一年营收范围"
            v-model="queryParams.lastYearYsfw"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item
          label="过去第二年营收范围："
          label-width="190px"
          prop="qnYsfw"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入过去第二年营收范围"
            v-model="queryParams.qnYsfw"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item
          label="过去第三年营收范围："
          label-width="190px"
          prop="dqnYsfw"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入过去第三年营收范围"
            v-model="queryParams.dqnYsfw"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item
          label="过去第一年税收："
          label-width="190px"
          prop="lastYearTax"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入过去第一年税收"
            v-model="queryParams.lastYearTax"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item label="过去第二年税收：" label-width="190px" prop="qnTax">
          <el-input
            style="width: 700px"
            placeholder="请输入过去第二年税收"
            v-model="queryParams.qnTax"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item
          label="过去第三年税收："
          label-width="190px"
          prop="dqnTax"
        >
          <el-input
            style="width: 700px"
            placeholder="请输入过去第三年税收"
            v-model="queryParams.dqnTax"
          />

          <span class="tag">万</span>
        </el-form-item>
      </div>

      <p class="info-title">企业梯度与荣誉</p>

      <div class="business-info-block">
        <el-form-item
          label="是否为规上企业："
          label-width="190px"
          prop="isRegulatedEnterprises"
        >
          <el-radio-group v-model="queryParams.isRegulatedEnterprises">
            <el-radio
              v-for="(item, index) in regulatedEnterprises"
              :key="index"
              :label="item.codeName"
            ></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="专精特新企业梯度："
          label-width="190px"
          prop="zjtxEnterprisesType"
        >
          <el-radio-group v-model="queryParams.zjtxEnterprisesType">
            <el-radio
              v-for="(item, index) in enterpriseCompnay"
              :key="index"
              :label="item.codeName"
            ></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否为国家高新技术企业：" label-width="190px">
          <div class="input-radio-box">
            <el-input style="width: 180px;" v-model="queryParams.gjgxjsEnterprises"></el-input>
            
            <el-radio-group v-model="queryParams.gjgxjsEnterprises">
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item
          label="企业荣誉："
          label-width="190px"
          prop="enterpriseHonors"
        >
          <div class="business-honor-tags">
            <el-tag
              :key="tag"
              v-for="tag in queryParams.enterpriseHonors"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag }}
            </el-tag>

            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="honorsValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>

            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >+ New Tag</el-button
            >
          </div>
        </el-form-item>
      </div>

      <p class="info-title">上市信息</p>

      <div class="business-info-block">
        <el-form-item
          label="是否为上市公司："
          label-width="190px"
          prop="isListedCompany"
        >
          <el-radio-group
            :value="
              !companyStockList || !companyStockList.length
                ? '非上市企业'
                : '上市企业'
            "
          >
            <el-radio
              v-for="(item, index) in query.listedCompany"
              :key="index"
              :label="item.label"
            ></el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-for="(item, index) in companyStockList" :key="index">
          <el-form-item
            label="上市板块："
            label-width="190px"
            prop="listedSector"
          >
            <el-input
              style="width: 700px"
              placeholder="请输入上市板块"
              v-model="item.stockType"
              disabled
            />
          </el-form-item>

          <el-form-item
            label="上市代码："
            label-width="190px"
            prop="listedCode"
          >
            <el-input
              style="width: 700px"
              placeholder="请输入上市代码"
              v-model="item.bondNum"
              disabled
            />
          </el-form-item>

          <el-form-item
            label="上市时间："
            label-width="190px"
            prop="listedTime"
          >
            <el-date-picker
              v-model="item.listedDate"
              type="datetime"
              placeholder="选择日期时间"
              style="width: 700px"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </div>

      <p class="info-title">异常信息</p>

      <div class="business-info-block">
        <el-form-item
          label="经营异常："
          label-width="190px"
          prop="abnormalOperation"
        >
          <el-radio-group v-model="queryParams.abnormalOperation">
            <el-radio
              v-for="(item, index) in query.judgeArray"
              :key="index"
              :label="item.label"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="司法异常："
          label-width="190px"
          prop="judicialAnomalies"
        >
          <el-radio-group v-model="queryParams.judicialAnomalies">
            <el-radio
              v-for="(item, index) in query.judgeArray"
              :key="index"
              :label="item.label"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </div>

      <p class="info-title">关联公司信息</p>

      <div class="business-info-block">
        <el-form-item
          label="是否有母公司："
          label-width="190px"
          prop="isParentCompany"
        >
          <el-radio-group v-model="queryParams.isParentCompany">
            <el-radio
              v-for="(item, index) in query.judgeArray"
              :key="index"
              :label="item.label"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="母公司编号："
          label-width="190px"
          prop="parentCompanyId"
        >
          <el-input
            style="width: 700px"
            v-model="queryParams.parentCompanyId"
          />
        </el-form-item>

        <el-form-item
          label="母公司名称："
          label-width="190px"
          prop="parentCompanyName"
        >
          <el-input
            style="width: 700px"
            v-model="queryParams.parentCompanyName"
          />
        </el-form-item>
      </div>

      <p class="info-title">服务覆盖主要区域</p>

      <div class="business-info-block">
        <div class="table-box ly_table_light">
          <el-table
            border
            style="width: 628px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column label="覆盖区域" align="left"> </el-table-column>
          </el-table>
        </div>

        <el-form-item
          label="赋能行业："
          label-width="190px"
          prop="parentCompanyId"
        >
          <SelectTreeRadio
            :isTree="true"
            apiName="getIndustryList"
            :params="{ groupLabelType: '赋能行业标签组' }"
            resultType="values"
            storageKey="industryCategoryList"
            v-model="queryParams.industryLabelList"
            :isCheckBoxButton="false"
            :isRadioFirstLevel="false"
          ></SelectTreeRadio>
        </el-form-item>
      </div>

      <p class="info-title">
        融资投资&nbsp;&nbsp;{{ queryParams.financingList.length }}
      </p>

      <div class="business-info-block">
        <el-form-item
          label="是否融资："
          label-width="190px"
          prop="isParentCompany"
        >
          <el-radio-group :value="!queryParams.financingList || !queryParams.financingList.length ? 0 : 1">
            <el-radio
              v-for="(item, index) in query.judgeArray"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <div class="table-box ly_table_light">
          <el-table
            border
            :data="queryParams.financingList"
            style="width: 1010px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column label="序号" prop="id" align="center">
            </el-table-column>

            <el-table-column label="披露日期" prop="pubTime" align="center">
              <template v-slot="{ row }">
                <span>
                  {{
                    row.pubTime
                      ? $dayjs(row.pubTime).format("YYYY-MM-DD HH:mm:ss")
                      : "-"
                  }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="事件日期" prop="date" align="center">
              <template v-slot="{ row }">
                <span>
                  {{
                    row.date
                      ? $dayjs(row.date).format("YYYY-MM-DD HH:mm:ss")
                      : "-"
                  }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="交易金额" prop="money" align="center">
            </el-table-column>

            <el-table-column label="融资轮次" prop="round" align="center">
            </el-table-column>

            <el-table-column label="估值" prop="value" align="center">
            </el-table-column>

            <el-table-column label="比例" prop="share" align="center">
            </el-table-column>

            <el-table-column label="投资方" prop="investorName" align="center">
            </el-table-column>

            <el-table-column label="新闻来源" prop="newsUrl" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <p class="info-title">
        知识产权&nbsp;&nbsp;{{ intellectualPropertySize }}
      </p>

      <div class="business-info-block">
        <div class="table-box ly_table_light">
          <p class="table-title">专利数据</p>

          <el-table
            :data="queryParams.propertyRightsList"
            border
            style="width: 1010px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column prop="id" label="专利编号" align="center">
            </el-table-column>

            <el-table-column prop="patentName" label="专利名称" align="center">
            </el-table-column>

            <el-table-column prop="inventor" label="发明人" align="center">
            </el-table-column>

            <el-table-column prop="patentType" label="专利类型" align="center">
            </el-table-column>

            <el-table-column
              prop="patentStatus"
              label="专利状态"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>

        <div class="table-box ly_table_light">
          <p class="table-title">软著数据</p>

          <el-table
            :data="queryParams.softwareRightsList"
            border
            style="width: 1010px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column prop="id" label="软著编号" align="center">
            </el-table-column>

            <el-table-column
              prop="softwareFullName"
              label="软著名称"
              align="center"
            >
            </el-table-column>

            <el-table-column prop="author" label="发明人" align="center">
            </el-table-column>

            <el-table-column
              prop="softwareType"
              label="软著类型"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="softwareState"
              label="软著状态"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
// api
import { getProductType } from "@/api/product";
import { getOperationInfo, updateOperationInfo } from "@/api/enterprise.js";
// components
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";

export default {
  components: {
    SelectTreeRadio
  },
  props: {
    enterpriseInfo: {
      type: Object
    }
  },
  data() {
    //这里存放数据
    return {
      rules: {
        companyFullName: [
          { required: true, message: "请输入公司全称", trigger: "blur" }
        ]
      },
      query: {
        judgeArray: [
          { label: "是", value: 1 },
          { label: "否", value: 0 }
        ],
        listedCompany: [
          { label: "上市企业", value: "上市企业" },
          { label: "非上市企业", value: "非上市企业" }
        ]
      },
      enterpriseSize: [], // 企业规模
      regulatedEnterprises: [], // 规上企业
      enterpriseCompnay: [], // 专精特新企业梯度
      listedCompanies: [], // 上市企业
      queryParams: {
        abnormalOperation: "", // 经营异常
        companyCode: "", // 企业主键
        companyEmail: "", // 企业邮箱
        companyLinkEdin: "", // 领英网址
        companySize: "", // 企业规模
        companyTelephone: "", // 企业电话
        companyWebsite: "", // 企业官网
        companyWechat: "", // 微信公众号
        companyWeibo: "", // 企业微博
        dqnTax: "", // 过去第三年税收
        dqnYsfw: "", // 过去第三年营收范围
        enterpriseHonors: [], // 企业荣誉
        financingList: [], // 融资信息列表
        gjgxjsEnterprises: "", // 是否为国家高新技术企业
        industryLabelList: [], // 赋能行业标签组
        isListedCompany: "", // 是否为上市公司
        isParentCompany: "", // 是否有母公司
        isRegulatedEnterprises: "", // 是否是规上企业
        judicialAnomalies: "", // 司法异常
        lastYearSbrs: "", // 过去第一年社保人数
        lastYearTax: "", // 过去第一年税收
        lastYearYsfw: "", // 过去第一年营收范围
        listedCode: "", // 上市代码
        listedSector: "", // 上市板块
        listedTime: "", // 上市时间 年月即可
        parentCompanyId: "", // 母公司编号
        parentCompanyName: "", // 母公司名称
        propertyRightsList: [], // 专利数据列表
        qnSbrs: "", // 过去第二年社保人数
        qnTax: "", // 过去第二年税收
        qnYsfw: "", // 过去第二年营收范围
        serviceCoverageArea: "", // 服务覆盖所在省-地级市/自治州
        socialSecurityNumber: "", // 当前社保人数
        softwareRightsList: [], // 软著数据列表
        taxpayerType: "", // 纳税人类型
        zjtxEnterprisesType: "" // 专精特新企业梯度
      },
      // 企业荣誉tag
      inputVisible: false,
      honorsValue: "",
      tableData: [],
      companyStockList: null
    };
  },
  computed: {
    intellectualPropertySize() {
      let count = 0;

      if (Array.isArray(this.queryParams.propertyRightsList)) {
        count += this.queryParams.propertyRightsList.length;
      }

      if (Array.isArray(this.queryParams.softwareRightsList)) {
        count += this.queryParams.softwareRightsList.length;
      }

      return count;
    }
  },
  created() {
    // 获取企业规模
    this.getLableFromDataSystem("enterpriseSize", "enterpriseSize", "047");

    // 获取规上企业
    this.getLableFromDataSystem(
      "regulatedEnterprises",
      "regulatedEnterprises",
      "025"
    );

    // 获取高新技术企业
    this.getLableFromDataSystem(
      "enterpriseCompnay",
      "enterpriseCompnay",
      "050"
    );

    // 获取上市企业
    // this.getLableFromDataSystem("listedCompanies", "listedCompanies", "024");
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }

      getOperationInfo({
        id: this.$route.query.companyCode
      }).then(res => {
        if (res.code == 200) {
          this.isInit = true;
          for (let key in this.queryParams) {
            if (["enterpriseHonors", "industryLabelList"].includes(key)) {
              if (Array.isArray(res.data[key]) && res.data[key].length) {
                this.queryParams[key] = res.data[key];
              } else {
                this.queryParams[key] = [];
              }
            } else {
              this.queryParams[key] = res.data[key];
            }
          }

          this.companyStockList = res.data.companyStockList;
          console.log(res.data);
        }
      });
    },
    submit() {
      this.$modal.loading("正在保存数据，请稍候...");

      updateOperationInfo(this.queryParams)
        .then(res => {
          if (res.code === 200) {
            this.$message.success("编辑成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    },
    // 从系统字典里获取数据
    async getLableFromDataSystem(storageName, keyName, dataCode) {
      let storageData = sessionStorage.getItem(storageName);

      if (!storageData) {
        try {
          const result = await getProductType({ code: dataCode });

          if (Array.isArray(result.data)) {
            sessionStorage.setItem(storageName, JSON.stringify(result.data));
            this[keyName] = result.data;
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        this[keyName] = JSON.parse(storageData);
      }
    },
    // 企业荣誉事件
    handleClose(tag) {
      this.queryParams.enterpriseHonors.splice(
        this.queryParams.enterpriseHonors.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      let inputValue = this.honorsValue;
      if (inputValue) {
        console.log(this.queryParams.enterpriseHonors);
        this.queryParams.enterpriseHonors.push(inputValue);
      }
      this.inputVisible = false;
      this.honorsValue = "";
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    }
  }
};
</script>

<style scoped lang="less">
.business-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .business-info-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
      border-bottom: 0;
    }

    .table-box {
      margin-top: 10px;
      padding-left: 190px;
      padding-bottom: 10px;

      .table-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
        color: #333333;

        &::before {
          content: "";
          display: block;
          margin-right: 4px;
          width: 7px;
          height: 7px;
          background-color: #1e9fff;
          border-radius: 50%;
        }
      }
    }
  }

  .tag {
    margin-left: 8px;
  }

  .input-radio-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
  }

  .business-honor-tags {
    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
}
</style>
